webpackJsonp([10],{

/***/ "3pAe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2Q_YC"};

/***/ }),

/***/ "5ttS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Footer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("ZMjw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { crossorigin: 'anonymous', alt: 'GDG Logo', src: 'https://firebasestorage.googleapis.com/v0/b/io-extended-android-19.appspot.com/o/gdg_logo_%20transparent_h50_tiny.png?alt=media&token=d551df03-5897-48df-8350-b92aff7b765a' });

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'a',
	{ href: 'https://io-extended-seoul-18.firebaseapp.com' },
	'I/O Extended Seoul 2018'
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'a',
	{ href: 'https://io-extended-seoul-17.firebaseapp.com' },
	'I/O Extended Seoul 2017'
);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'p',
	null,
	'\xA9 2019 Based on Project I/O Extended 2019 Kuala Lumpur PWA. Source originates from GDG KL'
);

var Footer = function (_Component) {
	_inherits(Footer, _Component);

	function Footer() {
		_classCallCheck(this, Footer);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Footer.prototype.render = function render(_ref) {
		var rootPath = _ref.rootPath;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footer },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footer_logo },
				_ref2
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footer_links },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footer_link },
					_ref3,
					_ref4,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: rootPath + 'faq' },
						'FAQ'
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: rootPath + 'coc' },
						'CoC'
					)
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.reference },
				_ref5
			)
		);
	};

	return Footer;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "7LhK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"social_footer":"social_footer__Onedb","social_body":"social_body__1kBPM","social_gif":"social_gif__-O59R"};

/***/ }),

/***/ "Qw5d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Register; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_io_logo__ = __webpack_require__("EzY6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_social_footer__ = __webpack_require__("jaA0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_footer__ = __webpack_require__("5ttS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__("3pAe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'h2',
	null,
	'Code of Conduct'
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'p',
	null,
	'GDG Korea Android \uB294 \uAC1C\uBC1C\uC790 \uC9C0\uD5A5 \uCEE4\uBBA4\uB2C8\uD2F0 \uADF8\uB8F9\uC73C\uB85C\uC11C \uAD8C\uB9AC \uCE68\uD574 \uC5C6\uB294 \uD589\uC0AC\uB97C \uC704\uD558\uC5EC \uD0C0\uC778\uC5D0\uAC8C \uBD88\uCF8C\uAC10\uC744 \uC904 \uC218 \uC788\uB294 \uC131 \uC815\uCCB4\uC131, \uC131\uC801 \uCDE8\uD5A5, \uC7A5\uC560, \uC678\uBAA8, \uBBFC\uC871, \uAD6D\uC801, \uC778\uC885, \uB098\uC774, \uC815\uCE58, \uC885\uAD50 \uB4F1\uC5D0 \uB300\uD55C \uBC1C\uC5B8\uC740 \uAE08\uC9C0\uD569\uB2C8\uB2E4.'
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'p',
	null,
	'\uD589\uB3D9\uAC15\uB839\uC740 Google Developers Group \uD589\uC0AC\uC5D0 \uCC38\uC5EC\uD558\uB294 \uBAA8\uB4E0 \uAC1C\uC778\uC5D0\uAC8C \uD574\uB2F9\uD558\uBA70 \uC704\uBC18 \uC2DC \uD1F4\uC7A5 \uB4F1\uC758 \uC81C\uC7AC\uB97C \uBC1B\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uD589\uB3D9\uAC15\uB839 \uC704\uBC18 \uC0AC\uB840\uC5D0 \uB300\uD55C \uB0B4\uC6A9\uC740 \uACF5\uAC1C\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. '
);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'h4',
	null,
	'1. \uC0AC\uB824 \uAE4A\uAC8C \uD589\uB3D9\uD574\uC8FC\uC138\uC694.'
);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'p',
	null,
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		null,
		'\uC6B0\uB9AC\uB294 \uBAA8\uB450 \uAC19\uC740 \uACF5\uB3D9\uCCB4\uC758 \uAD6C\uC131\uC6D0\uC785\uB2C8\uB2E4. \uADF8\uB7EC\uBBC0\uB85C \uB2E4\uB978 \uC0AC\uB78C\uB4E4\uC5D0\uAC8C \uCE5C\uC808\uD558\uAC8C \uADF8\uB9AC\uACE0 \uB530\uB4EF\uD558\uAC8C \uB9DE\uC774\uD558\uB294 \uC88B\uC740 \uC0AC\uB78C\uC774 \uB418\uC5B4\uC8FC\uC138\uC694. \uB2E4\uB978 \uC0AC\uB78C\uC774 \uD568\uAED8\uD558\uACE0 \uC2F6\uC5B4 \uD558\uB294 \uC0AC\uB78C\uC774 \uB418\uC5B4\uC8FC\uC138\uC694.'
	)
);

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'h4',
	null,
	'2. \uC11C\uB85C\uB97C \uC874\uC911\uD574 \uC8FC\uC138\uC694.'
);

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'p',
	null,
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		null,
		'\uD65C\uBC1C\uD55C \uD1A0\uB860\uC740 \uAC74\uAC15\uD55C \uAC1C\uBC1C\uC790 \uC0DD\uD0DC\uACC4\uC5D0 \uB3C4\uC6C0\uC774 \uB418\uC9C0\uB9CC, \uBE44\uD310\uC774 \uC544\uB2CC \uBE44\uB09C\uC740 \uD574\uAC00 \uB429\uB2C8\uB2E4. \uC758\uACAC\uC744 \uACF5\uAC10\uD558\uB824 \uB178\uB825\uD558\uACE0, \uAC08\uB4F1\uC744 \uB179\uC5EC\uAC00\uBA70 \uD568\uAED8\uD574\uC8FC\uC138\uC694. \uC11C\uB85C\uB97C \uC774\uD574\uD558\uAE30 \uC704\uD574 \uB178\uB825\uD574\uC8FC\uC138\uC694.'
	)
);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'h4',
	null,
	'3. \uB9D0\uACFC \uD589\uB3D9\uC5D0 \uCC45\uC784\uAC10\uC744 \uBCF4\uC5EC\uC8FC\uC138\uC694.'
);

var _ref10 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'p',
	null,
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		null,
		'\uC6B0\uB9AC\uB294 \uACF5\uB3D9\uCCB4\uC758 \uAD6C\uC131\uC6D0\uC73C\uB85C\uC11C \uD558\uB294 \uB9D0\uACFC \uD589\uB3D9\uC5D0 \uB300\uD574 \uCC45\uC784\uC774 \uC788\uC2B5\uB2C8\uB2E4. \uADF8\uB85C \uC778\uD574 \uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD55C\uB2E4\uBA74 \uBC14\uB85C\uC7A1\uC544\uC57C \uD569\uB2C8\uB2E4. \uC5B4\uB5A0\uD55C \uACBD\uC6B0\uB77C\uB3C4 \uB9D0\uACFC \uD589\uB3D9\uC73C\uB85C \uC778\uD574 \uD0C0\uC778\uC774 \uBD88\uCF8C\uAC10\uC744 \uB290\uAF08\uB2E4\uBA74 \uBB38\uC81C\uC5D0 \uD574\uB2F9\uB429\uB2C8\uB2E4.'
	)
);

var _ref11 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'h4',
	null,
	'4. \uC801\uADF9\uC801\uC73C\uB85C \uCC38\uC5EC\uD574\uC8FC\uC138\uC694.'
);

var _ref12 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'p',
	null,
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		null,
		'\uC801\uADF9\uC801\uC778 \uCC38\uC5EC\uB294 \uC11C\uB85C\uC758 \uAC70\uB9AC\uB97C \uC904\uC774\uACE0 \uBCF4\uB2E4 \uD070 \uAC00\uCE58\uB97C \uB9CC\uB4E4\uC5B4 \uB0C5\uB2C8\uB2E4. \uC801\uADF9\uC801\uC73C\uB85C \uCC38\uC5EC\uD558\uBA70 \uC870\uD654\uB86D\uAC8C \uC5B4\uC6B8\uB824\uC8FC\uC138\uC694.'
	)
);

var _ref13 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'h4',
	null,
	'5. \uC790\uC720\uB86D\uAC8C \uB3C4\uC6C0\uC744 \uAD6C\uD558\uC138\uC694.'
);

var _ref14 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'p',
	null,
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		null,
		'\uACE4\uB780\uD55C \uC0C1\uD669\uC744 \uB9C8\uC8FC\uCCE4\uB2E4\uBA74 \uC8FC\uC704\uC5D0 \uB3C4\uC6C0\uC744 \uC694\uCCAD\uD558\uC138\uC694. \uADF8\uB9AC\uACE0 \uB3C4\uC6C0\uC744 \uC694\uCCAD\uBC1B\uC558\uB2E4\uBA74 \uC8FC\uC800\uD558\uC9C0 \uB9D0\uACE0 \uB3C4\uC640\uC8FC\uC138\uC694.'
	)
);

var _ref15 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref16 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'p',
	null,
	'\uAC74\uAC15\uD55C \uACF5\uB3D9\uCCB4\uB97C \uC704\uD574 \uAD6C\uC131\uC6D0\uB4E4\uC740 \uC704 \uD589\uB3D9\uAC15\uB839\uC744 \uC900\uC218\uD558\uACE0, \uC8FC\uC758 \uBC1B\uC740 \uAD6C\uC131\uC6D0\uC740 \uC989\uC2DC \uD589\uB3D9\uAC15\uB839\uC744 \uC900\uC218\uD560 \uAC83\uC744 \uC694\uAD6C\uD569\uB2C8\uB2E4. \uC81C\uC7AC\uB97C \uBC1B\uC740 \uACBD\uC6B0 \uD589\uC0AC \uCC38\uC5EC\uB97C \uC704\uD574 \uC9C0\uBD88\uD55C \uBE44\uC6A9\uC740 \uB3CC\uB824\uBC1B\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uBAA8\uB4E0 \uAD6C\uC131\uC6D0\uC740 \uC790\uC2E0\uC774\uB098 \uB2E4\uB978 \uC0AC\uB78C\uC774 \uBD88\uD3B8\uC744 \uB290\uB07C\uAC8C \uD558\uB294 \uD589\uB3D9\uC744 \uBCF4\uC558\uC744 \uB54C \uC6B4\uC601\uC9C4\uC744 \uCC3E\uAC70\uB098 ',
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'a',
		{ href: 'mailto:gdg.korea+coc@gmail.com' },
		'gdg.korea+coc@gmail.com'
	),
	'. \uB85C \uBCF4\uB0B4\uC11C \uC54C\uB824\uC57C \uD569\uB2C8\uB2E4. \uC6B4\uC601\uC9C4\uC740 \uC774\uB97C \uC778\uC9C0\uD588\uC744 \uB54C \uC989\uC2DC \uD589\uB3D9\uC744 \uCDE8\uD574\uC57C \uD569\uB2C8\uB2E4.'
);

var _ref17 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref18 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'p',
	null,
	'\uC6B4\uC601\uC9C4\uC740 \uCC38\uAC00\uC790\uC5D0\uAC8C \uD754\uCF8C\uD788 \uB3C4\uC6C0\uC744 \uC8FC\uC5B4\uC57C \uD558\uBA70 \uCC38\uAC00\uC790\uC758 \uC548\uC804\uC744 \uC9C0\uD0A4\uAE30 \uC704\uD55C \uB178\uB825\uC744 \uD574\uC57C\uD569\uB2C8\uB2E4. \uADF8 \uB178\uB825\uC5D0\uB294 \uCC38\uAC00\uC790 \uBCF4\uD638, \uACBD\uCC30/\uC0AC\uBC95\uAE30\uAD00\uC73C\uB85C\uC758 \uC5F0\uB77D\uC744 \uD3EC\uD568\uD569\uB2C8\uB2E4.'
);

var Register = function (_Component) {
	_inherits(Register, _Component);

	function Register() {
		_classCallCheck(this, Register);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Register.prototype.handleScroll = function handleScroll() {
		var ele = document.querySelector('.topappbar.mdc-top-app-bar');
		if (document.documentElement.scrollTop < 56) {
			ele.setAttribute('top', true);
		} else {
			ele.removeAttribute('top');
		}
	};

	Register.prototype.componentDidMount = function componentDidMount() {
		document.title = 'Code Of Conduct';
		window.addEventListener('scroll', this.handleScroll, { passive: true });
		this.handleScroll();
	};

	Register.prototype.componentWillUnmount = function componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
		document.querySelector('.topappbar.mdc-top-app-bar').removeAttribute('top');
	};

	Register.prototype.render = function render(_ref) {
		var rootPath = _ref.rootPath;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'hero' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__components_io_logo__["a" /* default */], { rootPath: rootPath }),
				_ref2
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_4__style___default.a.container },
				_ref3,
				_ref4,
				_ref5,
				_ref6,
				_ref7,
				_ref8,
				_ref9,
				_ref10,
				_ref11,
				_ref12,
				_ref13,
				_ref14,
				_ref15,
				_ref16,
				_ref17,
				_ref18
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__components_social_footer__["a" /* default */], { rootPath: rootPath }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__components_footer__["a" /* default */], { rootPath: rootPath })
		);
	};

	return Register;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "ZMjw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__14P9B","footer_logo":"footer_logo__1TGSI","footer_link":"footer_link__1Xgw_","reference":"reference__26LtN"};

/***/ }),

/***/ "jaA0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SocialFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("7LhK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'p',
	null,
	'\uC544\uC9C1 GDG Korea\uC5D0 \uCC38\uC5EC\uB97C \uB9DD\uC124\uC774\uC2DC\uB098\uC694?'
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'p',
	null,
	'\uACE0\uBBFC\uD558\uC9C0 \uB9C8\uC2DC\uACE0 \uD3B8\uD55C \uB9C8\uC74C\uC73C\uB85C \uCC38\uC5EC\uD558\uC138\uC694!'
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'div',
	null,
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'a',
		{ alt: '', href: 'https://www.facebook.com/groups/gdg.korea.android/', target: '_blank', rel: 'noopener noreferrer' },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'svg',
			{ width: '40', height: '40', viewBox: '0 0 40 40', xmlns: 'http://www.w3.org/2000/svg' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'title',
				null,
				'GDG Korea Android Facebook Groups'
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'g',
				{ fill: 'none', 'fill-rule': 'evenodd', transform: 'translate(-52)' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'g',
					{ transform: 'translate(52)', fill: '#1a73e8' },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M17.1766667,30.88 L21.6726667,30.88 L21.6726667,19.9986667 L24.672,19.9986667 L25.0693333,16.2493333 L21.6726667,16.2493333 L21.6773333,14.372 C21.6773333,13.3946667 21.7706667,12.87 23.1733333,12.87 L25.048,12.87 L25.048,9.12 L22.048,9.12 C18.4446667,9.12 17.1766667,10.9393333 17.1766667,13.998 L17.1766667,16.2493333 L14.9306667,16.2493333 L14.9306667,19.9993333 L17.1766667,19.9993333 L17.1766667,30.88 L17.1766667,30.88 Z M20,40 C8.95466667,40 0,31.0453333 0,20 C0,8.954 8.95466667,0 20,0 C31.0453333,0 40,8.954 40,20 C40,31.0453333 31.0453333,40 20,40 Z' })
				)
			)
		)
	),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'a',
		{ href: 'https://www.meetup.com/GDG-Korea-Android/', target: '_blank', rel: 'noopener noreferrer' },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'svg',
			{ xmlns: 'http://www.w3.org/2000/svg', width: '40', height: '40', viewBox: '0 0 40 40' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'title',
				null,
				'GDG Korea Android Meetup'
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('circle', { fill: '#1a73e8', cx: '20', cy: '20', r: '20' }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { fill: '#fff', d: 'M32,28.24c-.31-1.93-3.88-.45-4.1-2.56-.31-3,4.15-9.46,3.8-12A2.92,2.92,0,0,0,28.51,11a3.09,3.09,0,0,0-2.05.44.79.79,0,0,1-1.12,0,11.49,11.49,0,0,0-.9-.82,1.84,1.84,0,0,0-1-.4A3.09,3.09,0,0,0,22,10.3a3.89,3.89,0,0,0-1,.75c-.33.28-1.15,1.2-1.92.86-.33-.15-1.45-.71-2.27-1.06-1.56-.68-3.82.42-4.63,1.87-1.22,2.15-3.6,10.6-4,11.71a3.32,3.32,0,0,0,3.51,4.43,2.61,2.61,0,0,0,2.41-1.64c.39-.69,4-10.09,4.25-10.54a1.17,1.17,0,0,1,1.39-.48,1.27,1.27,0,0,1,.58,1.42c-.13.9-2.67,6.63-2.77,7.28-.16,1.1.36,1.71,1.51,1.77a2.2,2.2,0,0,0,2.18-1.41c.35-.65,4.35-8.67,4.7-9.2s.71-.78,1.11-.76.8.1.68,1-3.35,6.78-3.68,8.22a4.26,4.26,0,0,0,2.34,4.73C27.51,29.81,32.37,30.74,32,28.24Z' })
		)
	),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'a',
		{ href: 'http://slack.gdg.kr', target: '_blank', rel: 'noopener noreferrer' },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'svg',
			{ xmlns: 'http://www.w3.org/2000/svg', width: '40', height: '40', viewBox: '0 0 24 24' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'title',
				null,
				'GDG Korea Slack'
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('circle', { fill: '#1a73e8', cx: '12', cy: '12', r: '12' }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { fill: '#fff', d: 'M18.82,14.06l-1.55.52.54,1.61A1.24,1.24,0,0,1,17,17.76,1.24,1.24,0,0,1,15.43,17l-.54-1.61-3.21,1.07.54,1.61a1.25,1.25,0,0,1-.79,1.58,1.34,1.34,0,0,1-.44.06,1.25,1.25,0,0,1-1.15-.85L9.3,17.22l-1.56.53a1.67,1.67,0,0,1-.44.06A1.28,1.28,0,0,1,6.15,17a1.22,1.22,0,0,1,.78-1.57l1.56-.53-1-3.09L6,12.29a1.07,1.07,0,0,1-.43.06,1.24,1.24,0,0,1-1.14-.84,1.26,1.26,0,0,1,.8-1.58l1.56-.52L6.2,7.81A1.25,1.25,0,0,1,8.57,7l.54,1.61L12.3,7.55l-.54-1.61a1.26,1.26,0,0,1,.79-1.57,1.24,1.24,0,0,1,1.57.79l.54,1.62,1.56-.51A1.24,1.24,0,0,1,17,8.63l-1.56.52,1,3.09L18,11.72a1.25,1.25,0,0,1,.8,2.37Z' }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { fill: '#1a73e8', d: 'M9.88,11l1,3.08L14.12,13l-1-3.07L9.88,11Z' })
		)
	)
);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { crossorigin: 'anonymous', alt: 'I/O 2019 Hashtag', src: 'https://res.cloudinary.com/limhenry/image/upload/v1552385648/ioxkl19_pwa/hashtag.png' });

var SocialFooter = function (_Component) {
	_inherits(SocialFooter, _Component);

	function SocialFooter() {
		_classCallCheck(this, SocialFooter);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	SocialFooter.prototype.render = function render(_ref) {
		var rootPath = _ref.rootPath;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.social_footer },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.social_body },
				_ref2,
				_ref3,
				_ref4
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.social_gif },
				_ref5
			)
		);
	};

	return SocialFooter;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ })

});


// WEBPACK FOOTER //
// route-coc.chunk.c66e5.js